/**
 * Photo Slice — Manages live photo capture state
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PhotoState {
  photoData: string | null; // base64 data URL
  captureTimestamp: string | null;
  retryCount: number;
}

const initialState: PhotoState = {
  photoData: null,
  captureTimestamp: null,
  retryCount: 0,
};

const photoSlice = createSlice({
  name: 'photo',
  initialState,
  reducers: {
    setPhoto: (state, action: PayloadAction<string>) => {
      state.photoData = action.payload;
      state.captureTimestamp = new Date().toISOString();
    },
    clearPhoto: (state) => {
      state.photoData = null;
      state.captureTimestamp = null;
      state.retryCount += 1;
    },
    resetPhoto: () => initialState,
  },
});

export const { setPhoto, clearPhoto, resetPhoto } = photoSlice.actions;
export default photoSlice.reducer;
